import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";

//
//
//
//
//
//
//
var GlobalTitle = function GlobalTitle() {
  return import(
  /* webpackChunkName:"global-editorial" */
  '~/components/atoms/Editorial/Global/GlobalTitle.vue');
};

export default {
  name: 'TitleSection',
  components: {
    GlobalTitle: GlobalTitle
  },
  props: {
    subtitle: {
      type: Object,
      required: true
    },
    textColor: {
      type: String,
      default: ''
    }
  }
};